<script setup lang="ts">
import { ref, onMounted } from 'vue'

const spriteUI = ref('')
const spriteFlags = ref('')
const spriteCards = ref('')
const spriteSocials = ref('')

onMounted(async () => {
  const resUI = await fetch('/portal/assets/svg/sprite-ui.svg')
  spriteUI.value = await resUI.text()
  const resFlags = await fetch('/portal/assets/svg/sprite-flags.svg')
  spriteFlags.value = await resFlags.text()
  const resCards = await fetch('/portal/assets/svg/sprite-cards.svg')
  spriteCards.value = await resCards.text()
  const resSocials = await fetch('/portal/assets/svg/sprite-socials.svg')
  spriteSocials.value = await resSocials.text()
})
</script>

<template>
  <div
    v-html="spriteUI"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteFlags"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteCards"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteSocials"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
</template>
